import { createFileRoute } from '@tanstack/react-router';

import { SolicitudesPage } from '@/features/compliance/components/solicitudes-page';
import { ComplianceSectionTabs } from '@/features/compliance/components/compliance-section-tabs';

export const Route = createFileRoute('/_app/compliance/arco')({
  component: ComplianceArcoRoute,
});

function ComplianceArcoRoute() {
  return (
    <div className="flex flex-col gap-6">
      <ComplianceSectionTabs />
      <SolicitudesPage />
    </div>
  );
}
